import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapFieldValueFromInternalToPublic } from '../../utils/map-field-value-from-internal-to-public';
/**
 * Initializes the field with all necessary data, also with the value.
 */
export var initializeField = function initializeField(_ref) {
  var field = _ref.field,
    metadata = _ref.metadata;
  return function (_ref2, _ref3) {
    var getState = _ref2.getState,
      setState = _ref2.setState;
    var viewType = _ref3.viewType;
    var _getState = getState(),
      internalFormMetadata = _getState.internalFormMetadata,
      _getState$formData = _getState.formData,
      formData = _getState$formData === void 0 ? {} : _getState$formData;
    var fieldMetadata = {
      allowedValues: field.allowedValues,
      isReadOnlyBySystem: field.isReadOnly,
      isRequiredBySystem: field.isRequired,
      fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
      fieldType: field.fieldType
    };
    var publicValue = mapFieldValueFromInternalToPublic({
      fieldMetadata: fieldMetadata,
      internalFieldValue: field.value,
      fieldType: field.fieldType,
      viewType: viewType
    });
    setState({
      formData: _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, field.fieldId, {
        fieldId: field.fieldId,
        fieldName: field.fieldName,
        description: field.description,
        isVisible: field.isVisible,
        fieldType: field.fieldType,
        isReadOnly: field.isReadOnly,
        isRequired: field.isRequired,
        value: publicValue,
        optionsVisibility: undefined
      })),
      internalFormMetadata: _objectSpread(_objectSpread({}, internalFormMetadata), {}, _defineProperty({}, field.fieldId, fieldMetadata))
    });
  };
};

/**
 * Initializes all fields with all necessary data, also with the value.
 */
export var initializeFields = function initializeFields(fields) {
  return function (_ref4, _ref5) {
    var setState = _ref4.setState;
    var viewType = _ref5.viewType;
    var _fields$reduce = fields.reduce(function (acc, _ref6) {
        var field = _ref6.field,
          metadata = _ref6.metadata;
        var fieldMetadata = {
          allowedValues: field.allowedValues,
          isReadOnlyBySystem: field.isReadOnly,
          isRequiredBySystem: field.isRequired,
          fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
          fieldType: field.fieldType
        };
        var publicValue = mapFieldValueFromInternalToPublic({
          fieldMetadata: fieldMetadata,
          internalFieldValue: field.value,
          fieldType: field.fieldType,
          viewType: viewType
        });
        acc.formData[field.fieldId] = {
          fieldId: field.fieldId,
          fieldName: field.fieldName,
          description: field.description,
          isVisible: field.isVisible,
          fieldType: field.fieldType,
          isReadOnly: field.isReadOnly,
          isRequired: field.isRequired,
          value: publicValue,
          optionsVisibility: undefined
        };
        acc.internalFormMetadata[field.fieldId] = fieldMetadata;
        return acc;
      }, {
        internalFormMetadata: {},
        formData: {}
      }),
      formData = _fields$reduce.formData,
      internalFormMetadata = _fields$reduce.internalFormMetadata;
    setState({
      formData: formData,
      internalFormMetadata: internalFormMetadata,
      numberOfSupportedFields: fields.length
    });
  };
};